const toObjectMap = <T extends string | number = string>(items: T[]) => {
    return items.reduce((obj, item) => {
        obj[item] = item;
        return obj;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {} as any) as { [key in typeof items[number]]: key };
};
const toObjectBooleanMap = <T extends string | number = string>(items: T[]) => {
    return items.reduce((obj, item) => {
        obj[item] = true;
        return obj;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {} as any) as { [key in typeof items[number]]: true };
};

export { toObjectMap, toObjectBooleanMap };
